export enum Category {
	Eat = 'eat',
	Shop = 'shop',
	Relax = 'relax',
}
